import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import BackToTop from '../../components/feature/BackToTop';
import LoadingScreen from '../../components/feature/LoadingScreen';
import SkipToContent from '../../components/feature/SkipToContent';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import ExpertiseSection from './components/ExpertiseSection';
import DifferentiatorSection from './components/DifferentiatorSection';
import TeamSection from './components/TeamSection';
import ContactSection from './components/ContactSection';

export default function Home() {
  useEffect(() => {
    document.title = 'ProEditions - Expert Business Writing Services | Grant Writing & Application Development';
  }, []);

  return (
    <>
      <LoadingScreen />
      <SkipToContent />
      <div className="min-h-screen bg-white">
        <Header />
        <main id="main-content" tabIndex={-1} role="main">
          <HeroSection />
          <ExpertiseSection />
          <ServicesSection />
          <DifferentiatorSection />
          <TeamSection />
          <ContactSection />
        </main>
        <Footer />
        <BackToTop />
      </div>
    </>
  );
}
